import "bootstrap/dist/css/bootstrap.min.css";
import "@riophae/vue-treeselect/dist/vue-treeselect.css"
import 'jquery-ui/themes/base/datepicker.css';
import 'jquery-ui/themes/base/theme.css';
import "./app.scss";
import { register } from "register-service-worker";



window.$ = window.jQuery = require('jquery');
require('jquery-ui/ui/widgets/datepicker.js');

// store original so we can call it inside our overriding method
$.datepicker._generateMonthYearHeader_original = $.datepicker._generateMonthYearHeader;

$.datepicker._generateMonthYearHeader = function(inst, dm, dy, mnd, mxd, s, mn, mns) {
  var header = $($.datepicker._generateMonthYearHeader_original(inst, dm, dy, mnd, mxd, s, mn, mns)),
      years = header.find('.ui-datepicker-year');

  if(years.is('select')) {
    // reverse the years
    years.html(Array.prototype.reverse.apply(years.children()));
  }

  // return our new html
  return $('<div />').append(header).html();
}

import "bootstrap";
/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from './router'

import Cookies from "js-cookie";
// Translations
import VueInternationalization from 'vue-i18n';
Vue.use(VueInternationalization);
import translations from './vue-locales.generated';

import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAovDkltS13gKSB3Jtwr-_OZbVrYiigs1E",
    libraries: ["places"], // necessary for places input
  }
});

import Vue2TouchEvents from 'vue2-touch-events';
Vue.use(Vue2TouchEvents, {
  disableClick: false,
  touchClass: '',
  tapTolerance: 10,
  touchHoldTolerance: 400,
  swipeTolerance: 30,
  longTapTimeInterval: 400
})

//let lang = 'en';
let lang = document.documentElement.getAttribute('lang');

// if (Cookies.get('app-language') !== undefined) {
//   lang = Cookies.get('app-language');
// }

const i18n = new VueInternationalization({
  locale: lang,
  messages: translations
});

Vue.config.productionTip = false;

// window.axios.interceptors.response.use(function (response) {
//   // Do something with response data
//   return response;
// }, function (error) {
//
//   // if (store.getters['website/user']) {
//   //   try {
//   //     await store.dispatch('website/fetchUser');
//   //   } catch (e) { }
//   // }
//
//   // Do something with response error
//   return Promise.reject(error);
// });

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount("#app");

/* eslint-disable no-console */

if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}serviceWorker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker."
      );
    },
    registered() {
      console.log("Service worker has been registered.");
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated() {
      console.log("New content is available; please refresh.");
      window.location.reload();
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    }
  });
}
